import React, { useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { navigate } from 'gatsby';

// import components
import PopupCard from 'components/partials/parts/popup-card';
import SearchFieldRow from "components/partials/search-field-row";

type SearchModalProps = {
    isOpen: boolean;
    closeModal: () => void;
    headline: string;
};

// https://reactcommunity.org/react-modal/accessibility/#app-element
ReactModal.setAppElement('#___gatsby');

const SearchModalBuilder: React.FC<React.PropsWithChildren<SearchModalProps>> = ({ isOpen, closeModal, headline, children }) => {
    // If modal is set to not open, return null
    if (!isOpen) {
        return null;
    }

    const [searchTerm, setSearchTerm] = useState('');

    const handleKeywordChange = (newKeyword: string) => {
        setSearchTerm(newKeyword);
    };

    const handleFormSubmit = (keyword: string) => {
        // gatsby navigate to search page with `q=keyword`
        navigate(`/search?q=${keyword}`, { replace: true });
        // be sure to close the modal
        closeModal();
    }

    const customStyles = {
        content: {
            animation: 'fadeIn 0.5s ease-in-out',
        },
    };

    return (
        <ReactModal
            isOpen={true}
            contentLabel={headline}
            className="popup-card"
            overlayClassName="popup-overlay bg-brand-teal"
            style={customStyles}
        >
            <PopupCard
                onClickClose={closeModal}
            >
                <SearchFieldRow 
                    header="Search" 
                    label="" 
                    buttonText="Search" 
                    searchParameter='search' 
                    initialSearch={searchTerm} 
                    onKeywordChange={handleKeywordChange}
                    onFormSubmit={handleFormSubmit} />
                {children}
            </PopupCard>
        </ReactModal>
    );
};

export default SearchModalBuilder;
